// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__URp-h","alert":"SettungsInbox_alert__gLsAV"};